import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bool } from "prop-types";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import Image from "pages/_components/Image";
import CustomText from "pages/_components/CustomText/CustomText";
import QR from "styles/images/app-download-qr.png";
import GooglePlayBtn from "styles/images/Google-Play.svg";
import AppleAppBtn from "styles/images/App-Store.svg";
import ArrowBack from "pages/_components/header/components/ArrowBack";
import { Button } from "react-bootstrap";

const StepStartOnMobile = ({ isDesktop }) => {
    const [playStoreUrl, setPlayStoreUrl] = useState(null);
    const [appStoreUrl, setAppStoreUrl] = useState(null);

    useEffect(() => {
        const iosID = configUtils.get("client.app.market.iosId", "bibank/id1536486674");
        const androidID = configUtils.get("client.app.market.androidId", "com.technisys.bibank.mobile");
        const playStoreURL = `${configUtils.get(
            "store.android.url",
            "https://play.google.com/store/apps/details?id=ANDROID_APP_ID&hl=en_US&pli=1",
        )}`.replace("ANDROID_APP_ID", androidID);
        const appStoreURL = `${configUtils.get("store.ios.url", "https://apps.apple.com/ar/app/")}${iosID}`;

        setPlayStoreUrl(playStoreURL);
        setAppStoreUrl(appStoreURL);
    }, []);

    return (
        <>
            <Notification scopeToShow="login" />
            {!isDesktop ? (
                <div className="logo-header">
                    <h1 className="inverse">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: i18n.get("downloadApp.title"),
                            }}
                        />
                    </h1>
                </div>
            ) : (
                <div className="download-app-arrow-back">
                    <ArrowBack />
                </div>
            )}
            <MainContainer className="align-items-center">
                <Image src="images/logoCompany.svg" className="svg-image logo" />
                {isDesktop && <img src={QR} alt="QR" className="justify-center download-app-qr" />}
                <div className="download-app-message">
                    <CustomText
                        text={i18n.get(
                            "register.download.app.message",
                            "Descargá la aplicación desde tu celular en la App Store para dispositivos Apple o Google Play para dispositivos Android.",
                        )}
                    />
                </div>
                <div className="download-apk-buttons justify-items-center">
                    {/* Google Play */}
                    <Button onClick={() => window.open(playStoreUrl)}>
                        <img src={GooglePlayBtn} alt="Download from google play store" className="justify-self-end" />
                    </Button>

                    {/* App Store */}
                    <Button onClick={() => window.open(appStoreUrl)}>
                        <img src={AppleAppBtn} alt="Download from app store" className="justify-self-start" />
                    </Button>
                </div>
            </MainContainer>
        </>
    );
};

StepStartOnMobile.propTypes = {
    isDesktop: bool.isRequired,
};
const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(StepStartOnMobile));
